import { useSelector } from 'react-redux';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../selectors/analytics';
import * as React from 'react';
import { trackPublicationWrapperShow } from '../tracking';
import { selectIsPackagesAvailable, selectIsPackageSelected } from '../../../reducers/v2/publicationPackages/selectors';
import { selectActivePackageServiceId } from '../../../reducers/v2/publicationPackages/selectors/selectActivePackageServiceId';

export const usePublicationSectionAnalytics = () => {
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const isPackagesAvailable = useSelector(selectIsPackagesAvailable);
  const isPackagesVisible = useSelector(selectIsPackageSelected);
  const activePackageServiceId = useSelector(selectActivePackageServiceId);

  React.useEffect(() => {
    trackPublicationWrapperShow({
      analyticsOfferStatus,
      analyticsProduct,
      isPackagesAvailable,
      isPackagesVisible,
      activePackageServiceId,
    });
  }, [activePackageServiceId, analyticsOfferStatus, analyticsProduct, isPackagesAvailable, isPackagesVisible]);
};
